import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

import { PanelHostService } from '../../../services/panel-host.service';
import { TripService } from '@services/trip.service';
import { TRIP_ID_QUERY_PARAM } from '../../../services/selected-trip-url/selected-trip-url.helpers';
import { ContentContainerComponent } from '../../ui/content-container/content-container.component';
import { PanelBodyComponent } from '../../ui/panel-body/panel-body.component';

@Component({
  selector: 'app-location-swap-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DatePipe, ContentContainerComponent, PanelBodyComponent],
  templateUrl: './location-swap-panel.component.html',
  styleUrls: ['./location-swap-panel.component.css']
})
export class LocationSwapPanelComponent {
  private readonly tripService = inject(TripService);
  private readonly panelHost = inject(PanelHostService);

  currentTrip = computed(() => this.tripService.currentTrip.value());

  trips = computed(() => {
    const trips = this.tripService.userTrips.value();

    if (!trips) {
      return [];
    }

    return trips.map((trip) => {
      return {
        ...trip,
        backgroundImage: 'todo',
        flagImage: 'todo'
      }
    })
  });

  activeTrips = computed(() => this.trips().filter(trip => !trip.hasEnded));

  pastTrips = computed(() => this.trips().filter(trip => trip.hasEnded));

  async setCurrentTrip(tripId: number): Promise<void> {
    if (tripId === this.tripService.currentTripId()) {
      await this.panelHost.dismiss();
      return;
    }

    const confirmed = await this.panelHost.confirmCloseIfDirty();
    if (!confirmed) {
      return;
    }

    this.tripService.setCurrentTrip(tripId);
    await this.panelHost.navigateAfterClose(['/dashboard'], {
      queryParams: { [TRIP_ID_QUERY_PARAM]: tripId },
    });
  }
}
